import styled from 'styled-components';
import CountDown from '../../utils/count-down';
import Icon, { ICON_STOPWATCH_LINE } from '~/components/icon/index';

const TimerContainer = styled.div`
	${props => props.inHeader && 'padding: 7px 10px;'}
	border-radius: 14px;
	color: rgba(var(--base-01), 1);
	height: 28px;
	margin-left: 12px;
	&.header-rc-coolOff {
		background-color: rgba(var(--cool-off-timer-bg, var(--info)), 1);
		display: flex;
		align-items: center;
	}
`;

const Timer = styled.span`
	padding-left: 4px;
	color: rgba(var(--cool-off-timer-color, var(--base-02)), 1);
`;

const CoolOffTimer = ({ coolOffTimeStamp, inHeader, className }) => {
	// function to pad add zeros to the start
	const zeroPad = (digit, value) => String(value).padStart(digit, '0');
	const renderer = ({ minutes, seconds, completed }) => {
		// format minutes to have 2 digits always
		const formattedSeconds = zeroPad(2, seconds);
		return !completed ? (
			<TimerContainer className={className} inHeader={inHeader}>
				{inHeader && <Icon type={ICON_STOPWATCH_LINE} height="13.5" width="13.5" />}
				<Timer>
					{minutes}:{formattedSeconds}
				</Timer>
			</TimerContainer>
		) : null;
	};

	if (coolOffTimeStamp < Date.now()) return null;

	return <CountDown date={coolOffTimeStamp} renderer={renderer} />;
};
export default CoolOffTimer;
